import { Action } from 'redux';
import { put, select } from '@redux-saga/core/effects';

import { routes } from 'routes';
import { AppState, ErrorAction } from 'store';
import { BasketActions, BasketActionTypes } from 'store/basket';
import { BasketSagaReturnType } from 'store/sagaHelpers';
import { validateBasketItems, errorToBasketErrorModel, ACTION_CREATOR_NAME, goToExternalUrl } from 'helpers';
import { BasketValidationResultModel } from 'models/Basket';

export interface ValidateCartAction extends Action<BasketActionTypes.VALIDATE_CART> {
    isBasketPage?: boolean;
}

export interface ValidateCartActionStart extends Action<BasketActionTypes.VALIDATE_CART_START> {
    isBasketPage?: boolean;
}

export interface ValidateCartActionSuccess extends Action<BasketActionTypes.VALIDATE_CART_SUCCESS> {
    validationResult: BasketValidationResultModel;
}

export interface ValidateCartActionError extends ErrorAction<BasketActionTypes.VALIDATE_CART_ERROR> {
}

export const validateCart: (isBasketPage: boolean) => ValidateCartAction = (isBasketPage: boolean) => ({
    type: BasketActionTypes.VALIDATE_CART,
    isBasketPage
});
validateCart[ACTION_CREATOR_NAME] = 'validateCart';

export type ValidateCartFunc = (...args: Parameters<typeof validateCart>) => void;

export function* validateCartSaga({ isBasketPage }: ValidateCartAction): BasketSagaReturnType {
    yield put<BasketActions>({
        type: BasketActionTypes.VALIDATE_CART_START,
        isBasketPage: isBasketPage
    });

    try {
        const state: AppState = yield select();
        const basket = state.basketState.basket;

        if (!basket || !basket.guid || !basket.deliveryAddress?.postcode) {
            yield put<BasketActions>({
                type: BasketActionTypes.VALIDATE_CART_SUCCESS,
                validationResult: { isValid: true, invalidItems: [], sofaShields: [] }
            });

            return true;
        }

        const validationResult: BasketValidationResultModel = validateBasketItems(basket);

        yield put<BasketActions>({
            type: BasketActionTypes.VALIDATE_CART_SUCCESS,
            validationResult: validationResult
        });

        if (!validationResult.isValid && !isBasketPage) {
            goToExternalUrl(routes.basket.path);
        } else if (!validationResult.isValid && isBasketPage && !state.basketState.isAllInvalidItemsRemovingProcessing) {
            yield put<BasketActions>({
                type: BasketActionTypes.SET_SHOW_INVALID_ITEMS_REMOVING_WARNING,
                shouldShowInvalidItemsRemovingWarning: true
            });
        }

        return true;
    } catch (error) {
        yield put<BasketActions>({
            type: BasketActionTypes.VALIDATE_CART_ERROR,
            error: errorToBasketErrorModel(error, 'validateCartSaga')
        });

        return false;
    }
}
